import { AxiosPromise } from 'axios';
import { QuickPhoneSearch } from '../../types/QuickPhoneSearch';
import { libApiInstance } from '../axios';

export function requestSearchQuickPhone(
    search: string,
    signal?: AbortSignal,
): AxiosPromise<QuickPhoneSearch[]> {
    return libApiInstance.post('/contacts/SearchQuickPhone', search, { signal });
}
